<div class="dialog">
  <h2 mat-dialog-title>
    {{ "commonDeleteDialog.title" | translate }}
  </h2>
  <div class="container" fxLayout="column" fxLayoutAlign="center center">
    <div class="common-delete-message">{{ message | translate: { target: data.target } }}</div>
    <mat-list>
      <mat-list-item *ngFor="let deletename of data.deleteNames">
        <p class="delete">{{ deletename }}</p>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
    <mat-dialog-actions>
      <button mat-button class="cancel-button" color="primary" mat-dialog-close>{{ "commonDeleteDialog.cancel" | translate }}</button>
      <button mat-raised-button color="warn" (click)="delete()">{{ "commonDeleteDialog.delete" | translate }}</button>
    </mat-dialog-actions>
  </div>
</div>
